export const widgetSettingColumnsCount = [
    {
        label: 'Одна',
        value: '1',
    },
    {
        label: 'Две',
        value: '2',
    },
];

export const widgetSettingFieldsBorder = [
    {
        label: 'По периметру',
        value: 'all',
    },
    {
        label: 'Только линия снизу',
        value: 'bottom',
    },
];


export const widgetSettingPrimaryButtonFilled = [
    {
        label: 'Заполненная',
        value: 'filled',
    },
    {
        label: 'Только контур',
        value: 'bordered',
    },
];


export const widgetSettingButtonLocation = [
    {
        label: 'Левый край',
        value: 'flex-start',
    },
    {
        label: 'По центру',
        value: 'center',
    },
    {
        label: 'Правый край',
        value: 'flex-end',
    },
];

export const yandexMetricaGoals = [
    {
        label: 'loadedForm',
        action: 'Просмотр формы виджета регистрации',
        goal: '[COMDI] widget loaded form',
    },
    {
        label: 'editedField',
        action: 'Заполнены все поля виджета регистрации',
        goal: '[COMDI] widget edited field',
    },
    {
        label: 'clickedButton',
        action: 'Нажата кнопка виджета «Регистрация» или «Подать заявку»',
        goal: '[COMDI] widget clicked button',
    },
    {
        label: 'requestSuccess',
        action: 'Завершение регистрации - «Заявка принята»',
        goal: '[COMDI] widget request success',
    },
    {
        label: 'registrationSuccess',
        action: 'Завершение регистрации - «Регистрация пройдена успешно»',
        goal: '[COMDI] widget registration success',
    },
];
